<!-- 首页页面 -->
<template>
    <div class="home-container">
        <!-- 动态科技背景 -->
        <div class="tech-bg">
            <div class="tech-bg-grid"></div>
            <div class="tech-bg-glow glow-1"></div>
            <div class="tech-bg-glow glow-2"></div>
            <div class="tech-bg-glow glow-3"></div>
            <div class="tech-bg-scanline"></div>
            <!-- 粒子 -->
            <span
                v-for="n in 26"
                :key="'p' + n"
                class="tech-particle"
                :style="particleStyle(n)"></span>
            <!-- 浮动光点连线 -->
            <svg class="tech-lines" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="lineGrad" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stop-color="#00d4ff" stop-opacity="0"></stop>
                        <stop offset="50%" stop-color="#00d4ff" stop-opacity="0.5"></stop>
                        <stop offset="100%" stop-color="#2d7cff" stop-opacity="0"></stop>
                    </linearGradient>
                </defs>
                <line v-for="(l, i) in lines" :key="'l' + i" v-bind="l" stroke="url(#lineGrad)" stroke-width="1"></line>
            </svg>
        </div>

        <!-- 顶部 -->
        <header class="home-header">
            <a class="home-logo" href="/">
                <img :src="logoSrc" alt="盛业信息科技">
            </a>
            <nav class="home-nav">
                <span
                    v-for="item in navList"
                    :key="item"
                    class="home-nav-item"
                    :class="{ active: item === '网站首页' }">{{ item }}</span>
            </nav>
            <div class="home-contact">
                <span class="home-contact-dot"></span>
                <span class="home-contact-text">400-066-9938</span>
            </div>
        </header>

        <!-- 主体内容 -->
        <main class="home-main">
            <div class="home-badge">
                <i class="home-badge-dot"></i>
                智能供应链金融科技平台
            </div>
            <h1 class="home-title">
                <span class="home-title-line">让供应链更高效</span>
                <span class="home-title-line gradient-text">金融更普惠</span>
            </h1>
            <p class="home-desc">
                融合大数据风控、人工智能与区块链技术，聚焦基建、医药、能源等国家战略型行业，为<br>核心企业、中小微供应商与金融机构打造一站式数字化协同云平台。
            </p>
            <div class="home-actions">
                <button class="home-btn primary" @click="goWebsite">
                    立即体验
                    <i class="home-btn-arrow"></i>
                </button>
                <button class="home-btn ghost">预约演示</button>
            </div>

            <!-- 数据指标 -->
            <ul class="home-stats">
                <li v-for="item in stats" :key="item.label" class="home-stat">
                    <p class="home-stat-num">
                        {{ item.value }}<span class="home-stat-unit">{{ item.unit }}</span>
                    </p>
                    <p class="home-stat-label">{{ item.label }}</p>
                </li>
            </ul>
        </main>

        <!-- 底部 ICP -->
        <footer class="home-footer">
            <p>
                ©{{ year }} SHENGYE CAPITAL ALL RIGHTS RESERVED
                <a class="home-icp" href="https://beian.miit.gov.cn" target="_blank" rel="noopener">
                    粤ICP备17033957号
                </a>
            </p>
        </footer>
    </div>
</template>

<script>
export default ({
    name: 'Index',
    data() {
        return {
            logoSrc: '/logo.svg',
            year: new Date().getFullYear(),
            navList: ['网站首页', '产品服务', '解决方案', '关于我们'],
            stats: [
                { value: '500', unit: '+', label: '合作核心企业' },
                { value: '1000', unit: '亿+', label: '累计撮合规模' },
                { value: '99.9', unit: '%', label: '系统可用性' },
                { value: '7×24', unit: 'h', label: '智能风控监控' }
            ],
            lines: []
        }
    },
    mounted() {
        this.buildLines()
    },
    methods: {
        goWebsite() {
            window.open('https://client.sytechnology.com/index')
        },
        // 粒子随机样式
        particleStyle(n) {
            const left = n * 37 % 100
            const top = n * 53 % 100
            const size = 2 + n % 4
            const delay = n % 10 * -3
            const duration = 8 + n % 7
            const cyan = n % 2 === 0
            return {
                left: left + '%',
                top: top + '%',
                width: size + 'px',
                height: size + 'px',
                background: cyan ? '#00d4ff' : '#2d7cff',
                animationDelay: delay + 's',
                animationDuration: duration + 's'
            }
        },
        // 构建装饰连线
        buildLines() {
            const pts = [
                { x: 12, y: 30 }, { x: 28, y: 18 }, { x: 45, y: 35 },
                { x: 68, y: 22 }, { x: 82, y: 40 }, { x: 90, y: 16 },
                { x: 20, y: 70 }, { x: 38, y: 82 }, { x: 60, y: 68 }, { x: 78, y: 80 }
            ]
            const result = []
            for (let i = 0; i < pts.length - 1; i++) {
                const a = pts[i]
                const b = pts[i + 1]
                if (Math.abs(a.x - b.x) < 40 && Math.abs(a.y - b.y) < 40) {
                    result.push({
                        x1: a.x + '%', y1: a.y + '%',
                        x2: b.x + '%', y2: b.y + '%'
                    })
                }
            }
            this.lines = result
        }
    }
})
</script>

<style lang="scss" scoped>
$bg-dark: #050a1a;
$bg-mid: #0a1535;
$bg-navy: #0e234b;
$cyan: #00d4ff;
$blue: #2d7cff;
$orange: #ff743c;

.home-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    overflow: hidden;
    background: radial-gradient(ellipse at 50% 0%, $bg-navy 0%, $bg-mid 45%, $bg-dark 100%);
    color: #fff;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
    display: flex;
    flex-direction: column;
}

/* ===== 背景 ===== */
.tech-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
}
.tech-bg-grid {
    position: absolute;
    inset: -50% 0 0;
    background-image:
        linear-gradient(rgba(0, 212, 255, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 212, 255, 0.08) 1px, transparent 1px);
    background-size: 60px 60px;
    transform: perspective(600px) rotateX(60deg);
    transform-origin: center top;
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent 75%);
    -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent 75%);
    animation: gridMove 8s linear infinite;
}
@keyframes gridMove {
    from { background-position: 0 0; }
    to { background-position: 0 60px; }
}
.tech-bg-glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.5;
    animation: glowFloat 14s ease-in-out infinite;
}
.glow-1 {
    width: 520px; height: 520px;
    left: -120px; top: -80px;
    background: radial-gradient(circle, rgba(0, 212, 255, 0.5), transparent 70%);
}
.glow-2 {
    width: 600px; height: 600px;
    right: -160px; top: 10%;
    background: radial-gradient(circle, rgba(45, 124, 255, 0.45), transparent 70%);
    animation-delay: -4s;
}
.glow-3 {
    width: 480px; height: 480px;
    left: 40%; bottom: -200px;
    background: radial-gradient(circle, rgba(255, 116, 60, 0.3), transparent 70%);
    animation-delay: -8s;
}
@keyframes glowFloat {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(30px, -20px) scale(1.1); }
}
.tech-bg-scanline {
    position: absolute;
    left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.6), transparent);
    top: 0;
    animation: scan 6s linear infinite;
}
@keyframes scan {
    from { top: 0; opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    to { top: 100%; opacity: 0; }
}
.tech-particle {
    position: absolute;
    border-radius: 50%;
    box-shadow: 0 0 8px currentColor;
    animation: particleRise linear infinite;
}
@keyframes particleRise {
    0% { transform: translateY(0); opacity: 0; }
    20% { opacity: 0.9; }
    80% { opacity: 0.9; }
    100% { transform: translateY(-120px); opacity: 0; }
}
.tech-lines {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
}

/* ===== 顶部 ===== */
.home-header {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 60px;
}
.home-logo {
    display: inline-block;
    height: 44px;
    line-height: 44px;
    img {
        height: 40px;
        vertical-align: middle;
        filter: drop-shadow(0 0 10px rgba(0, 212, 255, 0.4));
    }
}
.home-nav {
    display: flex;
    gap: 38px;
    .home-nav-item {
        font-size: 15px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        position: relative;
        padding: 4px 0;
        transition: color 0.3s;
        &:hover {
            color: #fff;
        }
        &.active {
            color: $cyan;
            &::after {
                content: '';
                position: absolute;
                left: 50%;
                bottom: -6px;
                transform: translateX(-50%);
                width: 20px;
                height: 2px;
                background: $cyan;
                box-shadow: 0 0 8px $cyan;
            }
        }
    }
}
.home-contact {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border: 1px solid rgba(0, 212, 255, 0.4);
    border-radius: 20px;
    background: rgba(0, 212, 255, 0.06);
    backdrop-filter: blur(6px);
    .home-contact-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: $cyan;
        box-shadow: 0 0 8px $cyan;
        animation: blink 1.6s ease-in-out infinite;
    }
    .home-contact-text {
        font-size: 15px;
        letter-spacing: 1px;
        color: #fff;
    }
}
@keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
}

/* ===== 主体 ===== */
.home-main {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 40px;
}
.home-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 13px;
    letter-spacing: 1px;
    color: $cyan;
    background: rgba(0, 212, 255, 0.08);
    border: 1px solid rgba(0, 212, 255, 0.3);
    margin-bottom: 28px;
    animation: fadeUp 0.8s ease both;
    .home-badge-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: $cyan;
        box-shadow: 0 0 6px $cyan;
    }
}
.home-title {
    font-size: 68px;
    line-height: 1.15;
    font-weight: 700;
    letter-spacing: 4px;
    margin: 0;
    .home-title-line {
        display: block;
        animation: fadeUp 0.8s ease both;
        &:nth-child(1) { animation-delay: 0.1s; }
        &:nth-child(2) { animation-delay: 0.25s; }
    }
}
.gradient-text {
    background: linear-gradient(90deg, $cyan, $blue 60%, $orange);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
.home-desc {
    max-width: 760px;
    margin: 30px auto 0;
    font-size: 16px;
    line-height: 1.9;
    color: rgba(255, 255, 255, 0.65);
    animation: fadeUp 0.8s ease 0.4s both;
}
.home-actions {
    margin-top: 40px;
    display: flex;
    gap: 20px;
    animation: fadeUp 0.8s ease 0.55s both;
}
.home-btn {
    cursor: pointer;
    font-size: 15px;
    letter-spacing: 2px;
    padding: 13px 34px;
    border-radius: 26px;
    border: none;
    outline: none;
    transition: all 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    &.primary {
        color: #fff;
        background: linear-gradient(90deg, $blue, $cyan);
        box-shadow: 0 6px 24px rgba(0, 212, 255, 0.4);
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 30px rgba(0, 212, 255, 0.6);
        }
        .home-btn-arrow {
            width: 6px;
            height: 6px;
            border-top: 2px solid #fff;
            border-right: 2px solid #fff;
            transform: rotate(45deg);
            transition: transform 0.3s;
        }
        &:hover .home-btn-arrow {
            transform: rotate(45deg) translate(2px, -2px);
        }
    }
    &.ghost {
        color: #fff;
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.3);
        &:hover {
            border-color: $cyan;
            color: $cyan;
            box-shadow: 0 0 16px rgba(0, 212, 255, 0.3);
        }
    }
}

/* ===== 数据指标 ===== */
.home-stats {
    margin-top: 60px;
    display: flex;
    gap: 64px;
    animation: fadeUp 0.8s ease 0.7s both;
    .home-stat {
        text-align: center;
        position: relative;
        &:not(:last-child)::after {
            content: '';
            position: absolute;
            right: -32px;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 36px;
            background: rgba(255, 255, 255, 0.15);
        }
        .home-stat-num {
            font-size: 40px;
            font-weight: 700;
            line-height: 1;
            background: linear-gradient(180deg, #fff, $cyan);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .home-stat-unit {
            font-size: 18px;
            margin-left: 2px;
        }
        .home-stat-label {
            margin-top: 10px;
            font-size: 13px;
            color: rgba(255, 255, 255, 0.5);
            letter-spacing: 1px;
        }
    }
}

@keyframes fadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to { opacity: 1; transform: translateY(0); }
}

/* ===== 底部 ===== */
.home-footer {
    position: relative;
    z-index: 2;
    padding: 18px 0 22px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(5, 10, 26, 0.5);
    backdrop-filter: blur(6px);
    p {
        text-align: center;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
        line-height: 18px;
        letter-spacing: 0.5px;
    }
}
.home-icp {
    padding-left: 8px;
    color: rgba(255, 255, 255, 0.4);
    transition: color 0.3s;
    &:hover {
        color: $cyan;
        text-decoration: underline;
    }
}

/* 小屏适配 */
@media (max-width: 768px) {
    .home-header { padding: 18px 20px; }
    .home-nav { display: none; }
    .home-title { font-size: 40px; letter-spacing: 2px; }
    .home-desc { font-size: 14px; }
    .home-stats { gap: 28px; flex-wrap: wrap; justify-content: center; }
    .home-stats .home-stat:not(:last-child)::after { display: none; }
    .home-stat-num { font-size: 30px; }
}
</style>
